<!--<mat-panel-title>
    <table>
        <tr>
            <td>
                <mat-icon class="material-symbols-outlined">{{ dialogData.MaterialIconName }}</mat-icon>
            </td>
            <td>
                &nbsp;
            </td>
            <td>
                <h2 *ngIf="!isEditingTitle" (click)="toggleEditTitle()">{{ dialogData.Title }}</h2>
                <input *ngIf="isEditingTitle" [value]="dialogData.Title" (blur)="toggleEditTitle()" (input)="updateTitle($event)" />
            </td>
        </tr>
    </table>
</mat-panel-title>-->
<mat-card-header class="login-header">
    <mat-card-title class="mat-card-title">
        <mat-icon class="material-symbols-outlined">
            {{ dialogData.MaterialIconName }}
        </mat-icon>
        <span>
            <h2 *ngIf="!isEditingTitle" (click)="toggleEditTitle()">{{ dialogData.Title }}</h2>
            <input *ngIf="isEditingTitle" [value]="dialogData.Title" (blur)="toggleEditTitle()" (input)="updateTitle($event)" />
        </span>
    </mat-card-title>
    <mat-card-subtitle class="mat-card-subtitle">
        <span *ngIf="!isEditingSubtitle" (click)="toggleEditSubtitle()">{{ dialogData.Subtitle }}</span>
        <input *ngIf="isEditingSubtitle" [value]="dialogData.Subtitle" (blur)="toggleEditSubtitle()" (input)="updateSubtitle($event)" />
    </mat-card-subtitle>
</mat-card-header>
<div>
    <mat-dialog-content>
        <ng-template dynamicHost></ng-template>
    </mat-dialog-content>
</div>
<br />
<!--<mat-divider></mat-divider>-->
<br />
<div>
    <table class="actions-right">
        <tr>
            <td>
                <button *ngIf="acceptButtonCaption && acceptButtonCaption.length > 0 && isPendingChanges" mat-button (click)="confirm()">{{ acceptButtonCaption }}</button>
            </td>
            <td>
                &nbsp;
            </td>
            <td>
                <button *ngIf="closeButtonCaption && closeButtonCaption.length > 0"mat-button (click)="cancel()">{{ closeButtonCaption }}</button>
            </td>
        </tr>
    </table>
</div>
